import React from 'react';
import type { MetricScopeKey } from '../data/constants.js';
import './time-filter.css';

interface MetricScopeFilterProps {
  selected: MetricScopeKey;
  onChange: (key: MetricScopeKey) => void;
}

// `+ LEGACY` only reads correctly beside `COMMERCIAL`, so each button carries
// the full wording as its accessible name.
const OPTIONS: { key: MetricScopeKey; label: string; title: string }[] = [
  { key: 'commercial', label: 'COMMERCIAL', title: 'Commercial facilities only' },
  { key: 'withLegacy', label: '+ LEGACY', title: 'Commercial + Legacy facilities' },
];

export function MetricScopeFilter({
  selected,
  onChange,
}: MetricScopeFilterProps): React.ReactElement {
  return (
    <div className="mc-time-filter" role="group" aria-label="Metric facility scope">
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          title={o.title}
          aria-label={o.title}
          aria-pressed={selected === o.key}
          className={`mc-time-filter__btn${selected === o.key ? ' mc-time-filter__btn--active' : ''}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
